import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/sbci/invoice'
import pathMap from 'src/paths/pathMap'

class SbciInvoiceRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.SBCI_INVOICE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.SBCI_INVOICE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.SBCI_INVOICE_ADD_EDIT_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.SBCI_INVOICE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.SBCI_INVOICE_DETAILS_VIEW,
        component: ViewPage
      },
    ]
  }
}

export default SbciInvoiceRoute
